import React, { useState ,useEffect} from 'react';
import axios from 'axios';
import {API_BASE_URL} from './Constants'
import { DatePicker } from 'antd';
import TutorList from './TutorList';
const DemoClass = () => {
    const [products, setProducts] = useState([]);
    useEffect(() => {
    const fetchFiles = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/book-demo`);

        setProducts(res.data);
      } catch (err) {
        console.error('Error fetching files', err);
      }
    };

    fetchFiles();
  }, []);
  
  return (
    <div>

<div className="overflow-x-auto">
  <table className="table table-lg">
    {/* head */}
    <thead className='bg-secondary'>
      <tr>
        <th>Sl</th>
        <th>Name</th>
        <th>Mobile</th>
        <th>Email</th>
        <th>Syllabus</th>
         <th>Grade</th>
         <th>Date</th>
          </tr>
    </thead>
    <tbody>
      {/* row 1
      {products.filter(product => product.role == 'tutor').map(product => (
      <tr>
        <th>{product.id}</th>
        <td>{product.name}</td>
        <td>{product.email}</td>
        <td>{product.role}</td>
      </tr>
      ))} */}
    

     {/* row 1 */}
      {products.map(product => {
         const newdate = new Date(product.created_at).toLocaleDateString();
         return (
           <tr className='hover:bg-base-300'>
             <th>{product.id}</th>
             <td>{product.full_name}</td>
              <td>{product.mobile_number}</td>
             <td>{product.email_address}</td>
             <td>{product.syllabus}</td>
             <td>{product.grade}</td>
             <td>{newdate}</td>
           </tr>
         );
      })}
    </tbody>
  </table>
</div>



    </div>
  )
}

export default DemoClass;